<template>
  <v-card color="#757575">
    <v-row class="pa-0 ma-0">
      <v-col cols="2" class="pa-0">
        <v-icon x-large class="pa-3 justify-center white--text">mdi-truck-delivery-outline</v-icon>
      </v-col>
      <v-col cols="10" class="pa-0 pl-2">
        <v-row
          v-if="manualCombinationResult?.resultCardMessage"
          class="mt-2 mr-3 px-0 white--text font-weight-bold justify-end"
        >
          {{ manualCombinationResult?.resultCardMessage }}
        </v-row>
        <v-row class="mb-2 mr-2 justify-end">
          <v-btn v-if="manualCombinationResult?.freightIds" light @click="goToFreightsAndClose">
            Szűrés
          </v-btn>
          <v-btn class="ml-2" color="primary" @click="closeCard">OK</v-btn>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script lang="ts">
import { ManualCombinationResult } from '../helpers/types/manualCombination';
import { mapActions } from 'vuex';
import Vue, { PropType } from 'vue';

declare module 'vue/types/vue' {
  interface Vue {
    hideManualCombineResultCard(jobId: string): void;
  }
}

export default Vue.extend({
  name: 'ManualCombineResultCard',
  props: {
    manualCombinationResult: { type: Object as PropType<ManualCombinationResult>, required: true }
  },
  data() {
    return {};
  },

  methods: {
    ...mapActions('app', ['hideManualCombineResultCard', 'deleteJobById']),

    async closeCard() {
      await this.hideManualCombineResultCard(this.manualCombinationResult.jobId);
    },

    goToFreightsAndClose() {
      this.$router.push({
        path: '/freights',
        query: {
          freightId: this.manualCombinationResult.freightIds!.join(',')
        }
      });

      // close AFTER navigation is triggered
      this.$nextTick(() => {
        this.closeCard();
      });
    }
  }
});
</script>
